import { useSelector } from 'react-redux';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { PastSubscriptionsSelectors } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.selectors';

import { pricesWithoutDiscountAB } from './featuresHelpers/features/quotaLandingPrices';

export const usePriceWithoutDiscount = () => {
    const hasActiveSub = useSelector(BillingDataSelectors.hasActiveSubscription);
    const lastSub = useSelector(PastSubscriptionsSelectors.latestSubsByExpires);
    if (pricesWithoutDiscountAB === 'b') {
        return hasActiveSub;
    }

    if (!lastSub) {
        return (pricesWithoutDiscountAB === 'c' && hasActiveSub) || (pricesWithoutDiscountAB === 'd' && hasActiveSub);
    }

    const wasPaid = !hasActiveSub && lastSub;
    const monthsFromNow = (Date.now() - lastSub.expires) / (1000 * 60 * 60 * 24 * 30);

    return (
        (pricesWithoutDiscountAB === 'c' && ((wasPaid && monthsFromNow < 3) || hasActiveSub)) ||
        (pricesWithoutDiscountAB === 'd' && ((wasPaid && monthsFromNow < 6) || hasActiveSub))
    );
};
